import { createFileRoute } from '@tanstack/react-router';

import { BrandingPage } from '../modules/org-branding/ui/pages/BrandingPage';

export const Route = createFileRoute('/_authenticated/dashboard/settings/')({
  component: BrandingPage,
  staticData: {
    breadcrumb: ['Manage', 'Settings', 'Branding'],
  },
});
